import React from 'react'

export default function PdfToExcel(props) {
  const { className } = props

  return (
    <div className={className ? className : ''}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 32 36"
      >
        <g clip-path="url(#a)">
          <path
            fill="currentColor"
            fill-opacity=".1"
            d="M30.7 6.2 25.4 1c-.3-.3-.7-.5-1.1-.4h-16c-1.1 0-2 .9-2 2v17c.3 0 .7-.1 1-.1 5.1-.1 9.3 4 9.4 9.1 0 .9-.1 1.8-.4 2.7h12.9c1.1 0 2.1-.9 2.1-2v-22c-.1-.4-.3-.8-.6-1.1Z"
            opacity=".1"
          />
          <path
            fill="currentColor"
            d="M31.2 5.8 26 .7c-.5-.4-1.1-.7-1.8-.7H8.6c-1.7 0-3 1.3-3.1 2.9v16.8c.3-.1.7-.1 1-.2V3c0-1.1.9-2 2-2h15.7c.4 0 .8.2 1.1.4l5.2 5.1c.3.3.5.7.5 1.1V29c0 1.1-.9 2-2 2H16.3c-.1.3-.2.7-.3 1h13c1.7 0 3-1.3 3-3V7.6c0-.7-.3-1.3-.8-1.8Z"
          />
          <path
            fill="currentColor"
            d="M7.5 30H4c-.3 0-.5-.2-.5-.4v-2.1c0-.3.2-.5.4-.5h3.6v-2.3c0-.1.1-.2.2-.2s.1 0 .2.1l4.2 3.9c.1.1.1.2 0 .3l-4.2 3.8c-.1.1-.2.1-.3 0l-.1-.1V30Zm0-9C3.4 21 0 24.3 0 28.5S3.3 36 7.5 36s7.5-3.3 7.5-7.5c-.1-4.1-3.4-7.4-7.5-7.5Z"
          />
          <path
            fill="currentColor"
            fill-opacity=".1"
            d="M7.5 30H4c-.3 0-.5-.2-.5-.4v-2.1c0-.3.2-.5.4-.5h3.6v-2.3c0-.1.1-.2.2-.2s.1 0 .2.1l4.2 3.9c.1.1.1.2 0 .3l-4.2 3.8c-.1.1-.2.1-.3 0l-.1-.1V30Z"
          />
          <path
            fill="#12A64D"
            d="M13.09 11.75a.26.26 0 0 1 .192.087.31.31 0 0 1 .08.211V13.6c0 .08-.028.155-.08.211a.26.26 0 0 1-.192.088h-2.942a.26.26 0 0 1-.192-.088.313.313 0 0 1-.08-.21v-1.552a.31.31 0 0 1 .08-.21.26.26 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.397v-.954h-2.396v.954Z"
          />
          <path
            fill="#12A64D"
            d="M16.031 11.75a.26.26 0 0 1 .193.087c.051.056.08.132.08.211V13.6c0 .08-.029.155-.08.211a.26.26 0 0 1-.193.088H13.09a.26.26 0 0 1-.193-.088.313.313 0 0 1-.08-.21v-1.552c0-.079.03-.155.08-.21a.26.26 0 0 1 .193-.088h2.941Zm-2.669 1.551h2.397v-.954h-2.397v.954Z"
          />
          <path
            fill="#12A64D"
            d="M18.973 11.75a.26.26 0 0 1 .193.087.32.32 0 0 1 .08.211V13.6c0 .08-.03.155-.08.211a.26.26 0 0 1-.193.088h-2.942a.26.26 0 0 1-.192-.088.313.313 0 0 1-.08-.21v-1.552a.31.31 0 0 1 .08-.21.26.26 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.398v-.954h-2.397v.954Z"
          />
          <path
            fill="#12A64D"
            d="M21.915 11.75a.26.26 0 0 1 .192.087c.051.056.08.132.08.211V13.6c0 .08-.029.155-.08.211a.26.26 0 0 1-.192.088h-2.942a.26.26 0 0 1-.193-.088.313.313 0 0 1-.08-.21v-1.552c0-.079.03-.155.08-.21a.26.26 0 0 1 .193-.088h2.942Zm-2.67 1.551h2.397v-.954h-2.397v.954Z"
          />
          <path
            fill="#12A64D"
            d="M24.856 11.75a.26.26 0 0 1 .193.087.32.32 0 0 1 .08.211V13.6c0 .08-.03.155-.08.211a.26.26 0 0 1-.193.088h-2.942a.26.26 0 0 1-.192-.088.314.314 0 0 1-.08-.21v-1.552a.31.31 0 0 1 .08-.21.26.26 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.398v-.954h-2.397v.954Z"
          />
          <path
            fill="#12A64D"
            d="M27.798 11.75a.26.26 0 0 1 .192.087c.051.056.08.132.08.211V13.6c0 .08-.029.155-.08.211a.26.26 0 0 1-.192.088h-2.942a.26.26 0 0 1-.193-.088.313.313 0 0 1-.08-.21v-1.552c0-.079.03-.155.08-.21a.26.26 0 0 1 .193-.088h2.942Zm-2.67 1.551h2.397v-.954H25.13v.954Zm-12.038 0a.26.26 0 0 1 .192.087.31.31 0 0 1 .08.211v1.551c0 .08-.028.155-.08.211a.261.261 0 0 1-.192.088h-2.942a.261.261 0 0 1-.192-.088.313.313 0 0 1-.08-.21v-1.552a.31.31 0 0 1 .08-.21.261.261 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.397v-.954h-2.396v.954Z"
          />
          <path
            fill="#12A64D"
            d="M16.031 13.301a.26.26 0 0 1 .193.087c.051.056.08.132.08.211v1.551c0 .08-.029.155-.08.211a.261.261 0 0 1-.193.088H13.09a.261.261 0 0 1-.193-.088.313.313 0 0 1-.08-.21v-1.552c0-.079.03-.155.08-.21a.261.261 0 0 1 .193-.088h2.941Zm-2.669 1.551h2.397v-.954h-2.397v.954Z"
          />
          <path
            fill="#12A64D"
            d="M18.973 13.301c.072 0 .142.031.193.087a.32.32 0 0 1 .08.211v1.551c0 .08-.03.155-.08.211a.261.261 0 0 1-.193.088h-2.942a.261.261 0 0 1-.192-.088.313.313 0 0 1-.08-.21v-1.552a.31.31 0 0 1 .08-.21.261.261 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.398v-.954h-2.397v.954Z"
          />
          <path
            fill="#12A64D"
            d="M21.915 13.301a.26.26 0 0 1 .192.087c.051.056.08.132.08.211v1.551c0 .08-.029.155-.08.211a.26.26 0 0 1-.192.088h-2.942a.26.26 0 0 1-.193-.088.313.313 0 0 1-.08-.21v-1.552c0-.079.03-.155.08-.21a.26.26 0 0 1 .193-.088h2.942Zm-2.67 1.551h2.397v-.954h-2.397v.954Z"
          />
          <path
            fill="#12A64D"
            d="M24.856 13.301c.072 0 .142.031.193.087a.32.32 0 0 1 .08.211v1.551c0 .08-.03.155-.08.211a.261.261 0 0 1-.193.088h-2.942a.261.261 0 0 1-.192-.088.314.314 0 0 1-.08-.21v-1.552a.31.31 0 0 1 .08-.21.261.261 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.398v-.954h-2.397v.954Z"
          />
          <path
            fill="#12A64D"
            d="M27.798 13.301a.26.26 0 0 1 .192.087c.051.056.08.132.08.211v1.551c0 .08-.029.155-.08.211a.261.261 0 0 1-.192.088h-2.942a.261.261 0 0 1-.193-.088.313.313 0 0 1-.08-.21v-1.552c0-.079.03-.155.08-.21a.261.261 0 0 1 .193-.088h2.942Zm-2.67 1.551h2.397v-.954H25.13v.954Zm-12.038 0a.26.26 0 0 1 .192.087.31.31 0 0 1 .08.211v1.551c0 .08-.028.155-.08.211a.261.261 0 0 1-.192.088h-2.942a.261.261 0 0 1-.192-.088.313.313 0 0 1-.08-.21V15.15a.31.31 0 0 1 .08-.21.261.261 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.397v-.954h-2.396v.954Z"
          />
          <path
            fill="#12A64D"
            d="M16.031 14.852a.26.26 0 0 1 .193.087c.051.056.08.132.08.211v1.551c0 .08-.029.155-.08.211a.261.261 0 0 1-.193.088H13.09a.261.261 0 0 1-.193-.088.313.313 0 0 1-.08-.21V15.15c0-.079.03-.155.08-.21a.261.261 0 0 1 .193-.088h2.941Zm-2.669 1.551h2.397v-.954h-2.397v.954Z"
          />
          <path
            fill="#12A64D"
            d="M18.973 14.852c.072 0 .142.031.193.087a.32.32 0 0 1 .08.211v1.551c0 .08-.03.155-.08.211a.261.261 0 0 1-.193.088h-2.942a.261.261 0 0 1-.192-.088.313.313 0 0 1-.08-.21V15.15a.31.31 0 0 1 .08-.21.261.261 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.398v-.954h-2.397v.954Z"
          />
          <path
            fill="#12A64D"
            d="M21.915 14.852a.26.26 0 0 1 .192.087c.051.056.08.132.08.211v1.551c0 .08-.029.155-.08.211a.26.26 0 0 1-.192.088h-2.942a.26.26 0 0 1-.193-.088.313.313 0 0 1-.08-.21V15.15c0-.079.03-.155.08-.21a.26.26 0 0 1 .193-.088h2.942Zm-2.67 1.551h2.397v-.954h-2.397v.954Z"
          />
          <path
            fill="#12A64D"
            d="M24.856 14.852c.072 0 .142.031.193.087a.32.32 0 0 1 .08.211v1.551c0 .08-.03.155-.08.211a.261.261 0 0 1-.193.088h-2.942a.261.261 0 0 1-.192-.088.314.314 0 0 1-.08-.21V15.15a.31.31 0 0 1 .08-.21.261.261 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.398v-.954h-2.397v.954Z"
          />
          <path
            fill="#12A64D"
            d="M27.798 14.852a.26.26 0 0 1 .192.087c.051.056.08.132.08.211v1.551c0 .08-.029.155-.08.211a.261.261 0 0 1-.192.088h-2.942a.261.261 0 0 1-.193-.088.313.313 0 0 1-.08-.21V15.15c0-.079.03-.155.08-.21a.261.261 0 0 1 .193-.088h2.942Zm-2.67 1.551h2.397v-.954H25.13v.954Zm-12.038 0a.26.26 0 0 1 .192.088c.052.055.08.131.08.21v1.551c0 .08-.028.155-.08.211a.26.26 0 0 1-.192.088h-2.942a.26.26 0 0 1-.192-.088.313.313 0 0 1-.08-.21V16.7a.31.31 0 0 1 .08-.21.26.26 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.397V17h-2.396v.954Z"
          />
          <path
            fill="#12A64D"
            d="M16.031 16.403a.26.26 0 0 1 .193.088.31.31 0 0 1 .08.21v1.551c0 .08-.029.155-.08.211a.26.26 0 0 1-.193.088H13.09a.26.26 0 0 1-.193-.088.313.313 0 0 1-.08-.21V16.7c0-.079.03-.155.08-.21a.26.26 0 0 1 .193-.088h2.941Zm-2.669 1.551h2.397V17h-2.397v.954Z"
          />
          <path
            fill="#12A64D"
            d="M18.973 16.403a.26.26 0 0 1 .193.088c.05.055.08.131.08.21v1.551c0 .08-.03.155-.08.211a.26.26 0 0 1-.193.088h-2.942a.26.26 0 0 1-.192-.088.313.313 0 0 1-.08-.21V16.7a.31.31 0 0 1 .08-.21.26.26 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.398V17h-2.397v.954Z"
          />
          <path
            fill="#12A64D"
            d="M21.915 16.403a.26.26 0 0 1 .192.088.31.31 0 0 1 .08.21v1.551c0 .08-.029.155-.08.211a.26.26 0 0 1-.192.088h-2.942a.26.26 0 0 1-.193-.088.313.313 0 0 1-.08-.21V16.7c0-.079.03-.155.08-.21a.26.26 0 0 1 .193-.088h2.942Zm-2.67 1.551h2.397V17h-2.397v.954Z"
          />
          <path
            fill="#12A64D"
            d="M24.856 16.403a.26.26 0 0 1 .193.088c.05.055.08.131.08.21v1.551c0 .08-.03.155-.08.211a.26.26 0 0 1-.193.088h-2.942a.26.26 0 0 1-.192-.088.314.314 0 0 1-.08-.21V16.7a.31.31 0 0 1 .08-.21.26.26 0 0 1 .192-.088h2.942Zm-2.67 1.551h2.398V17h-2.397v.954Z"
          />
          <path
            fill="#12A64D"
            d="M27.798 16.403a.26.26 0 0 1 .192.088.31.31 0 0 1 .08.21v1.551c0 .08-.029.155-.08.211a.26.26 0 0 1-.192.088h-2.942a.26.26 0 0 1-.193-.088.313.313 0 0 1-.08-.21V16.7c0-.079.03-.155.08-.21a.26.26 0 0 1 .193-.088h2.942Zm-2.67 1.551h2.397V17H25.13v.954Zm-14.98-5.906h-.436v6.324h.436v-6.324Z"
          />
          <path
            fill="#12A64D"
            d="M10.148 11.75a.26.26 0 0 1 .193.087.32.32 0 0 1 .08.211v6.324c0 .079-.03.155-.08.21a.26.26 0 0 1-.193.088h-.436a.26.26 0 0 1-.192-.087.313.313 0 0 1-.08-.211v-6.324a.31.31 0 0 1 .08-.21.26.26 0 0 1 .192-.088h.436Z"
          />
          <path
            fill="currentColor"
            fill-rule="evenodd"
            d="M15.584 3c.388 0 .646.263.646.657v6.047c-.129.263-.388.526-.646.526H9.646c-.387 0-.646-.263-.646-.657V3.657C9 3.263 9.259 3 9.646 3h5.938Zm-3.98 3.798-1.506-2.63h1.506l.965 1.839.99-1.838h1.495l-1.522 2.629 1.564 2.63h-1.49l-1.036-1.82-1.02 1.818h-1.506l1.561-2.63Z"
            clip-rule="evenodd"
          />
        </g>
        <defs>
          <clipPath id="a">
            <path fill="#fff" d="M0 0h32v36H0z" />
          </clipPath>
        </defs>
      </svg>
    </div>
  )
}
